/**
 * Repeater Helper
 * Handles repeater field duplication and deletion
 */

import { FormConfig } from '../core/form_config.js';

export class RepeaterHelper {
  static formEngine = null;

  /**
   * Setup repeater handlers
   * @param {FormEngine} engine - Form engine instance
   */
  static setup(engine) {
    this.formEngine = engine;

    // Duplicate button handler - use closest() so clicking the icon counts as clicking the button
    document.addEventListener('click', (e) => {
      const button = e.target.closest('.duplicate');
      if (button && button.closest('.repeater')) {
        e.preventDefault();
        this.handleDuplicate(button);
      }
    }, true);

    // Delete button handler
    document.addEventListener('click', (e) => {
      const button = e.target.closest('.delete_repeater');
      if (button) {
        e.preventDefault();
        this.handleDelete(button);
      }
    }, true);
  }

  /**
   * Handle duplicate click: add a new empty row (rendered from config, no cloning).
   * @param {Element} button - Duplicate button
   */
  static handleDuplicate(button) {
    const engine = this.formEngine;
    if (!engine || !engine.formConfig) return;

    const areaElement = button.closest('.area');
    if (!areaElement) return;

    const areaId = areaElement.getAttribute('data-id');
    if (!areaId) return;

    const area = FormConfig.getAreaById(engine.formConfig, areaId);
    if (!area) return;

    const container = button.closest('.container-fluid');
    if (!container) return;

    const existingRows = container.querySelectorAll('.colsListWrapper');
    const newRowIndex = existingRows.length;

    const newRow = engine.renderEmptyRepeaterRow(area, newRowIndex);
    if (!newRow) return;

    const repeater = button.closest('.repeater');
    if (repeater && repeater.parentNode) {
      repeater.parentNode.insertBefore(newRow, repeater);
    }

    setTimeout(() => {
      newRow.querySelectorAll('.bind_nice_select').forEach(select => {
        select.classList.remove('bind_nice_select');
        if (window.NiceSelect) {
          window.NiceSelect.bind(select);
        }
      });
      engine.reinitializeFieldHandlers(newRow);
      if (engine.initDatePickers) engine.initDatePickers(newRow);
    }, 100);

    if (engine.notifyDraftChanged) engine.notifyDraftChanged();
  }

  /**
   * Handle delete click
   * @param {Element} button - Delete button
   */
  static handleDelete(button) {
    const wrapper = button.closest('.colsListWrapper');
    if (wrapper) {
      wrapper.remove();
      if (this.formEngine && this.formEngine.notifyDraftChanged) this.formEngine.notifyDraftChanged();
    }
  }

  /**
   * Add N repeater rows (e.g. when loading entry data that has more rows than currently in DOM).
   * @param {Element} anchorElement - Any element inside the repeater area (e.g. an input)
   * @param {number} count - Number of rows to add
   */
  static addRows(anchorElement, count) {
    if (!anchorElement || count <= 0) return;
    const container = anchorElement.closest('.container-fluid');
    if (!container) return;
    const duplicateButton = container.querySelector('.repeater .duplicate');
    if (!duplicateButton) return;
    for (let i = 0; i < count; i++) {
      this.handleDuplicate(duplicateButton);
    }
  }
}
